<template>
  <div>
    <template v-if="product.flapData?.status === 'available' && product.eanLabel?.status === 'available'">
      <template v-if="product.flapData?.availableInCountries[culture.country]">
        <p>
          {{ appTranslate('Click on a label to download as PDF') }}
          <!-- <select v-model="selectedRenderFormat">
            <option v-for="format of RenderFormats" :key="format" :value="format">{{ format.toUpperCase() }}</option>
          </select> -->
        </p>

        <PrintWarnings :availability="product.availability" />

        <div class="position-relative w-fit-content">
          <p class="mt-4">Flärp med fram och baksida 40x54mm</p>
          <LoaderComponent v-if="downloading" size="medium" inner overlay />
          <FlapComponent
            class="link d-inline-flex"
            :product="product"
            :flap-data="product.flapData"
            :ean-label-data="product.eanLabel"
            :culture="culture"
            show-outlines
            @click="handleDownload"
          />
        </div>
      </template>
      <template v-else>
        {{ appTranslate('Flaps are not available for %s', [getLocaleString(culture)]) }}
        <img :src="getFlag(culture.country)" class="small-flag" />
      </template>
    </template>

    <template v-else-if="product.flapData?.status === 'unavailable'">
      {{ appTranslate(product.flapData?.reason) }}
    </template>
  </div>
</template>

<script setup lang="ts">
import LoaderComponent from '@/components/simple/LoaderComponent.vue'
import { useTools } from '@/composables/useTools'
import { useTranslation } from '@/composables/useTranslation'
import { RenderFormat, RenderFormats } from '@/models/Ean'
import { Culture } from '@/models/Global'
import { SimplifiedProduct } from '@/models/Product'
import DataService from '@/services/DataService'
import { getLocaleString } from '@/utils/tools.js'
import { defineProps, ref } from 'vue'
import PrintWarnings from '../PrintWarnings.vue'
import FlapComponent from './FlapComponent.vue'

const props = defineProps<{
  product: SimplifiedProduct
  culture: Culture
}>()

const { appTranslate } = useTranslation()
const { getFlag } = useTools()

const downloading = ref(false)
const selectedRenderFormat = ref<RenderFormat>('pdf')

const handleDownload = async () => {
  if (!downloading.value) {
    downloading.value = true

    try {
      await DataService.downloadFlap(props.product.sku, selectedRenderFormat.value)
    } finally {
      downloading.value = false
    }
  }
}
</script>

<style lang="scss" scoped></style>
